import { createListenerMiddleware } from '@reduxjs/toolkit';
import { ApiStage } from 'core/constants/enums/ApiStages.ts';
import { ACCOUNT, PAYMENT_SUCCESSFUL } from 'core/navigation/Routes'; // NOTE: getOneTimePayLinkMiddleware
import {
	getManageSubscriptionsLinkAsync,
	getOneTimePayLinkAsync,
	getSubscriptionPayLinkAsync,
} from 'core/store/reducers/profileReducer/ProfileSlice';

// NOTE: getOneTimePayLinkMiddleware
// DESCRIPTION: middleware to implement sideEffect of getOneTimePayLinkMiddleware.fulfilled
// i.e when get one time pay link api is successful
// this middleware redirects user to payUrl returned by backend
const getOneTimePayLinkMiddleware = createListenerMiddleware();
getOneTimePayLinkMiddleware.startListening({
	actionCreator: getOneTimePayLinkAsync.fulfilled,
	effect: async (action) => {
		const payUrl = action.payload;
		window.open(payUrl, '_self', 'rel=noopener noreferrer');
	},
});

// NOTE: getSubscriptionPayLinkMiddleware
// DESCRIPTION: middleware to implement sideEffect of getSubscriptionPayLinkMiddleware.fulfilled
// i.e when get subscription pay link api is successful
// this middleware redirects user to payUrl returned by backend
const getSubscriptionPayLinkMiddleware = createListenerMiddleware();
getSubscriptionPayLinkMiddleware.startListening({
	actionCreator: getSubscriptionPayLinkAsync.fulfilled,
	effect: async (action, listenerApi) => {
		const { payUrl, price, transactionStatus } = action.payload;
		window.open(payUrl, '_self', 'rel=noopener noreferrer');

		const { userProfileDetails } = listenerApi.getState().app;
		if (userProfileDetails.showProratedPrices && transactionStatus === ApiStage.SUCCESS) {
			window.location.href = `/${ACCOUNT}/${PAYMENT_SUCCESSFUL}${!Number.isNaN(price / 100) ? `?value=${price / 100}` : ''}`;
		}
	},
});

// NOTE: getManageSubscriptionsLinkMiddleware
// DESCRIPTION: middleware to implement sideEffect of getManageSubscriptionsLinkAsync.fulfilled
// i.e when get manage-subscriptions link api is successful
// this middleware redirects user to url returned by backend
const getManageSubscriptionsLinkMiddleware = createListenerMiddleware();
getManageSubscriptionsLinkMiddleware.startListening({
	actionCreator: getManageSubscriptionsLinkAsync.fulfilled,
	effect: async (action) => {
		const manageSubscriptionsUrl = action.payload;
		window.open(manageSubscriptionsUrl, '_self', 'rel=noopener noreferrer');
	},
});

const canvasFeedMiddleware = (store) => (next) => (action) => {
	// First, let the action go through
	const result = next(action);

	// Check if this is a setCanvasId action
	if (action.type === 'canvas/setCanvasId' && action.payload !== '') {
		const state = store.getState();
		const canvasId = action.payload;
		const canvasFeedData = state.canvas.canvasFeedDataMap[canvasId] || { media: {}, assets: {} };

		// Create separate lists for media and assets
		store.dispatch({
			type: 'canvas/setCanvasPendingUpdateLists',
			payload: {
				mediaList: Object.values(canvasFeedData.media || {}),
				assetsList: Object.values(canvasFeedData.assets || {}),
			},
		});
	}

	return result;
};

export const getCommonMiddleware = (getDefaultMiddleware) =>
	getDefaultMiddleware({
		serializableCheck: {
			ignoredActions: ['persist/PERSIST', 'persist/REHYDRATE'],
		},
	}).prepend(
		getOneTimePayLinkMiddleware.middleware,
		getSubscriptionPayLinkMiddleware.middleware,
		getManageSubscriptionsLinkMiddleware.middleware,
		canvasFeedMiddleware,
	);
